import React from 'react';

export default function (props) {
  return(
   <div>
     <span>
      <h3 className="text-center">
        { props.text || 'Select the MID you want to login to'}
      </h3>
     </span>
   </div>
  );
}